"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65026],{

/***/ 61166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15064);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        .ant-table-thead > tr > th,\n        .ant-table-tbody > tr > td {\n          border: none;\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-table-cell {\n      padding: 0 !important;\n    }\n    .ant-table-thead > tr > th,\n    .ant-table-tbody > tr > td {\n      border-bottom: 1px solid ",
        ";\n    }\n\n    .ant-table-tbody > tr {\n      position: relative;\n    }\n    .ant-table-tbody > tr:hover > td {\n      background: ",
        ";\n    }\n    .ant-pagination-item-active{\n      border-color : ",
        ";\n    }\n    .ant-pagination-item-active a,\n    .ant-pagination-item:focus a, \n    .ant-pagination-item:hover a{\n      color : ",
        "\n    }\n\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    shouldForwardProp: function(props) {
        return ![
            "borderless"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        borderless: props.borderless
    };
}).withConfig({
    componentId: "sc-43a24ac8-0"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(param) {
    var borderless = param.borderless;
    return borderless && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
}));


/***/ }),

/***/ 90636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony exports loadingSelector, profileSelector, holdingCompositionSelector, corpActionSelector, consensusSelector, insiderSelector, seasonalitySelector, keystatSelector, financialSelector, analystSelector, analystConsensusSelector, loadingAnalystConsensusSelector, messageSelector, errorSelector, financialParamsSelector, pinnedPostSelector, actions */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1349);
/* harmony import */ var lib_api_stream__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51679);
/* harmony import */ var utils_company__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4168);








// APIs



var holdingCompositionInitialState = {
    data: {},
    error: {},
    isLoading: false
};
var corpActionInitialState = {};
// Initial State
var initialState = {
    profile: {},
    holdingComposition: holdingCompositionInitialState,
    corpAction: corpActionInitialState,
    consensus: {},
    insider: {},
    seasonality: {},
    keystat: {},
    financial: {},
    analyst: {},
    analystConsensus: {},
    isLoading: false,
    isLoadingAnalystConsensus: false,
    isLoadingCompanySubsidiary: false,
    message: "",
    error: null,
    financialParams: {
        report: 1,
        statement: 1
    },
    pinnedPost: {
        data: {},
        isLoading: {},
        message: {},
        error: {}
    },
    companySubsidiary: {}
};
// Selector
var companySelector = function(state) {
    return state.companyProfile;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(companySelector, function(company) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, company);
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.isLoading;
}, function(state) {
    return state;
});
var profileSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.profile;
}, function(state) {
    return state;
});
var holdingCompositionSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.holdingComposition;
}, function(state) {
    return state;
});
var corpActionSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.corpAction;
}, function(state) {
    return state;
});
var consensusSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.consensus;
}, function(state) {
    return state;
});
var insiderSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.insider;
}, function(state) {
    return state;
});
var seasonalitySelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.seasonality;
}, function(state) {
    return state;
});
var keystatSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.keystat;
}, function(state) {
    return state;
});
var financialSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.financial;
}, function(state) {
    return state;
});
var analystSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.analyst;
}, function(state) {
    return state;
});
var analystConsensusSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.analystConsensus;
}, function(state) {
    return state;
});
var loadingAnalystConsensusSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.isLoadingAnalystConsensus;
}, function(state) {
    return state;
});
var messageSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.message;
}, function(state) {
    return state;
});
var errorSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.error;
}, function(state) {
    return state;
});
var financialParamsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.financialParams;
}, function(state) {
    return state;
});
var pinnedPostSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.companyProfile.pinnedPost;
}, function(state) {
    return state;
});
// Action types
var CONTEXT = "@feature/company-profile";
var actionType = {
    GET_PROFILE_INFO: "".concat(CONTEXT, "/GET_PROFILE_INFO"),
    GET_HOLDING_COMPOSITION: "".concat(CONTEXT, "/GET_PROFILE_HOLDING_COMPOSITION"),
    GET_CONSENSUS: "".concat(CONTEXT, "/GET_CONSENSUS"),
    GET_ALL_CORP_ACTION: "".concat(CONTEXT, "/GET_ALL_CORP_ACTION"),
    GET_CORP_ACTION: "".concat(CONTEXT, "/GET_CORP_ACTION"),
    GET_COMPANY_INSIDER: "".concat(CONTEXT, "/GET_COMPANY_INSIDER"),
    GET_COMPANY_SEASONALITY: "".concat(CONTEXT, "/GET_COMPANY_SEASONALITY"),
    GET_KEYSTAT: "".concat(CONTEXT, "/GET_KEYSTAT"),
    GET_FINANCIAL_REPORT: "".concat(CONTEXT, "/GET_FINANCIAL_REPORT"),
    GET_ANALYST: "".concat(CONTEXT, "/GET_ANALYST"),
    GET_PINNED_POST: "".concat(CONTEXT, "/GET_PINNED_POST"),
    GET_ANALYST_CONSENSUS: "".concat(CONTEXT, "/GET_ANALYST_CONSENSUS"),
    GET_COMPANY_SUBSIDIARY: "".concat(CONTEXT, "/GET_COMPANY_SUBSIDIARY")
};
var actions = (/* unused pure expression or super */ null && (actionType));
// Effects
var effects = {
    getCompanyProfile: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_PROFILE_INFO, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanyProfile */ .Z.getCompanyProfile(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company profile info failed");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    getAllCorpAction: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_ALL_CORP_ACTION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getAllCorpAction */ .Z.getAllCorpAction(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get all corp. action of ".concat(symbol, " failed!"));
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            message: message,
                            data: data,
                            symbol: symbol
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyCorpAction: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_CORP_ACTION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, category, response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, category = param.category;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanyCorpAction */ .Z.getCompanyCorpAction(symbol, category);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get corp. action ".concat(category, " failed"));
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol,
                            category: category
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyInsider: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_COMPANY_INSIDER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, page, response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, page = param.page;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanyMajorholder */ .Z.getCompanyMajorholder({
                            symbol: symbol,
                            page: page
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get company insider failed");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data.movement,
                            message: message,
                            symbol: symbol,
                            isMore: data.is_more,
                            page: page
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanySeasonality: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_COMPANY_SEASONALITY, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, year, backYear, response, _data, _$error, message, oldData, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, year = param.year, backYear = param.backYear;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanySeasonality */ .Z.getCompanySeasonality(symbol, year, backYear);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get company seasonality failed");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, oldData = _data.data;
                        data = oldData || {};
                        if (oldData) {
                            data = utils_company__WEBPACK_IMPORTED_MODULE_3__/* ["default"].transformResponseSeasonalityFromServer */ .Z.transformResponseSeasonalityFromServer(oldData);
                        }
                        if (!_$error) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 12:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyKeystat: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_KEYSTAT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
            var getKeystat, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanyKeystat */ .Z.getCompanyKeystat(symbol);
                    case 3:
                        getKeystat = _ctx.sent;
                        if (getKeystat.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company keystat failed");
                    case 6:
                        _data = getKeystat.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            symbol: symbol
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    getFinancialReport: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_FINANCIAL_REPORT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
            var symbol, params, response, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = _param.symbol, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
                            "symbol"
                        ]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getFinancialReport */ .Z.getFinancialReport((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            symbol: symbol
                        }, params));
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get financial report failed");
                    case 7:
                        _$error = response.error, data = response.data, message = response.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }()),
    getAnalystRating: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_ANALYST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
            var analystRating, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getAnalystRating */ .Z.getAnalystRating(symbol);
                    case 3:
                        analystRating = _ctx.sent;
                        if (analystRating.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company keystat failed");
                    case 6:
                        _data = analystRating.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            symbol: symbol
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    getAnalystConsensus: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_ANALYST_CONSENSUS, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
            var analystConsensus, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getAnalystConsensus */ .Z.getAnalystConsensus(symbol);
                    case 3:
                        analystConsensus = _ctx.sent;
                        if (analystConsensus.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company keystat failed");
                    case 6:
                        _data = analystConsensus.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            symbol: symbol
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    getPinnedPost: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_PINNED_POST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
            var response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (symbol) {
                            _ctx.next = 3;
                            break;
                        }
                        throw new Error("Symbol is required!");
                    case 3:
                        _ctx.next = 5;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getCompanyPinnedPost */ .Z.getCompanyPinnedPost(symbol);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to get company pinned post failed");
                    case 8:
                        _data = response.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 11:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    14
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanySubsidiary: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_COMPANY_SUBSIDIARY, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
            var companySubsidiary, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanySubsidiary */ .Z.getCompanySubsidiary(symbol);
                    case 3:
                        companySubsidiary = _ctx.sent;
                        if (companySubsidiary.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company keystat failed");
                    case 6:
                        _data = companySubsidiary.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            symbol: symbol
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {
    updateFinancialParams: function(state, action) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
            financialParams: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.financialParams, action.payload)
        });
    },
    updateLoadingState: function(state, action) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
            isLoading: action.payload.isLoading
        });
    },
    resetErrorState: function(state) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
            error: null
        });
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getCompanyProfile.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, symbol = _payload.symbol, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            state.profile[symbol] = data;
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(effects.getAllCorpAction.pending, function(state, action) {
        var ref;
        var symbol = action.meta.arg;
        state.corpAction[symbol] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.corpAction[symbol]), {
            all: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (ref = state.corpAction[symbol]) === null || ref === void 0 ? void 0 : ref.all), {
                isLoading: true
            })
        });
    }).addCase(effects.getAllCorpAction.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.corpAction[symbol] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.corpAction[symbol]), {
                all: {
                    isLoading: false,
                    data: data.map(function(x) {
                        // BE res is 'stock_reverse' for category 'reversesplit', so we need to map it to our key
                        if (x.action_type === "stock_reverse") {
                            return {
                                action_type: "reversesplit",
                                action_info: {
                                    reversesplit: x.action_info.stock_reverse
                                }
                            };
                        }
                        return x;
                    })
                }
            });
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getCompanyCorpAction.pending, function(state, action) {
        var ref;
        var _arg = action.meta.arg, symbol = _arg.symbol, category = _arg.category;
        state.corpAction[symbol] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.corpAction[symbol]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, category, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (ref = state.corpAction[symbol]) === null || ref === void 0 ? void 0 : ref[category]), {
            isLoading: true
        })));
    }).addCase(effects.getCompanyCorpAction.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, symbol = _payload.symbol, category = _payload.category, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            var keys = Object.keys(data);
            keys.forEach(function(item) {
                if (Array.isArray(data[item])) {
                    state.corpAction[symbol] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.corpAction[symbol]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, category, {
                        isLoading: false,
                        data: data[item]
                    }));
                }
            });
        }
        state.message = message;
    }).addCase(effects.getCompanyInsider.pending, function(state, action) {
        var page = action.meta.arg.page;
        if (page === 1) {
            state.isLoading = true;
        }
    }).addCase(effects.getCompanyInsider.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, symbol = _payload.symbol, page = _payload.page;
        if (error) {
            state.error = error;
        } else {
            var insiderSymbol = state.insider[symbol] || [];
            state.insider[symbol] = page === 1 ? data : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(insiderSymbol).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(data));
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(effects.getCompanySeasonality.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.seasonality[symbol] = data;
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(effects.getCompanyKeystat.pending, function(state) {
        state.isLoading = true;
    }).addCase(effects.getCompanyKeystat.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.keystat[symbol] = data;
        }
        state.isLoading = false;
    }).addCase(effects.getFinancialReport.pending, function(state) {
        state.isLoading = true;
    }).addCase(effects.getFinancialReport.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.financial[symbol] = data;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getAnalystRating.pending, function(state) {
        state.isLoading = true;
    }).addCase(effects.getAnalystRating.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.analyst[symbol] = data;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getAnalystConsensus.pending, function(state) {
        state.isLoadingAnalystConsensus = true;
    }).addCase(effects.getAnalystConsensus.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.analystConsensus[symbol] = data;
        }
        state.message = message;
        state.isLoadingAnalystConsensus = false;
    }).addCase(effects.getPinnedPost.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getPinnedPost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.pinnedPost.data[symbol] = data;
            state.error = null;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getPinnedPost.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.payload.error;
    }).addCase(effects.getCompanySubsidiary.pending, function(state) {
        state.isLoadingCompanySubsidiary = true;
    }).addCase(effects.getCompanySubsidiary.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.companySubsidiary[symbol] = data;
        }
        state.message = message;
        state.isLoadingCompanySubsidiary = false;
    });
};
var companyProfileSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "companyProfile",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (companyProfileSlice);


/***/ }),

/***/ 99376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var requestExodusNoAlert = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false);
var FUNDACHART_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/fundachart");
var getFundachartMetric = function() {
    return requestExodus.get("".concat(FUNDACHART_URL, "/metrics?metric_name=fundachart"));
};
var getFundachart = function(params) {
    return requestExodus.get(FUNDACHART_URL, {
        params: params
    });
};
var getFundachartTemplate = function() {
    return requestExodus.get("".concat(FUNDACHART_URL, "/templates"));
};
var saveFundachartTemplate = function(data) {
    return requestExodus.post(FUNDACHART_URL, data);
};
var removeFundachartTemplate = function(templateId) {
    return requestExodus.delete("".concat(FUNDACHART_URL, "/").concat(templateId));
};
var getFundachartDefaultData = function(token) {
    return fetch("".concat(FUNDACHART_URL, "/data?token=").concat(token), {
        method: "GET"
    });
};
var getFundachartToken = function(body) {
    return body ? requestExodusNoAlert.post("".concat(FUNDACHART_URL, "/tokens"), body) : requestExodusNoAlert.post("".concat(FUNDACHART_URL, "/tokens"));
};
var getFundachartKeystatData = function(param) {
    var token = param.token, symbol = param.symbol, params = param.params;
    return fetch("".concat(FUNDACHART_URL, "/").concat(symbol, "/ratios?").concat(params), {
        method: "GET",
        headers: {
            Authorization: token
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getFundachartMetric: getFundachartMetric,
    getFundachart: getFundachart,
    getFundachartTemplate: getFundachartTemplate,
    saveFundachartTemplate: saveFundachartTemplate,
    removeFundachartTemplate: removeFundachartTemplate,
    getFundachartDefaultData: getFundachartDefaultData,
    getFundachartToken: getFundachartToken,
    getFundachartKeystatData: getFundachartKeystatData
});


/***/ }),

/***/ 60913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ entities_comparison; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/comparison.ts


var request = (0,requestExodus/* default */.Z)();
var COMPARISON_URL = "".concat(api/* API_EXODUS_URL */.q7, "/comparison");
var getComparisonMetric = function() {
    return request.get("".concat(COMPARISON_URL, "/metrics"));
};
var getIndustrySectorRatio = function(symbol) {
    return request.get("".concat(COMPARISON_URL, "/").concat(symbol, "/industries"));
};
var getComparison = function(param) {
    var symbol = param.symbol;
    return request.get("".concat(COMPARISON_URL, "/").concat(symbol, "/ratios"));
};
var getComparisonTemplate = function(symbol) {
    return request.get("".concat(COMPARISON_URL, "/").concat(symbol, "/templates"));
};
var saveComparisonTemplate = function(data) {
    return request.post("".concat(COMPARISON_URL, "/templates"), data);
};
var deleteComparisonTemplate = function(templateId) {
    return request.delete("".concat(COMPARISON_URL, "/templates/").concat(templateId));
};
var loadComparisonTemplate = function(templateId) {
    return request.get("".concat(COMPARISON_URL, "/templates/").concat(templateId));
};
/* harmony default export */ var comparison = ({
    getComparisonMetric: getComparisonMetric,
    getComparison: getComparison,
    getComparisonTemplate: getComparisonTemplate,
    saveComparisonTemplate: saveComparisonTemplate,
    deleteComparisonTemplate: deleteComparisonTemplate,
    loadComparisonTemplate: loadComparisonTemplate,
    getIndustrySectorRatio: getIndustrySectorRatio
});

;// CONCATENATED MODULE: ./src/lib/entities/comparison.ts
/* eslint-disable no-return-assign */ 







// APIs
// Initial state
var initialState = {
    competitors: [],
    metric: [],
    template: {},
    comparison: {},
    isLoading: true,
    error: null,
    message: "",
    shouldLoadDetail: false
};
// selectors
var comparisonSelector = function(state) {
    return state.entities.comparison;
};
var selectors = (0,es/* createSelector */.P1)(comparisonSelector, function(comparison) {
    return (0,_object_spread/* default */.Z)({}, comparison);
});
// Action types
var CONTEXT = "@redux/comparison";
var actionType = {
    GET_METRIC: "".concat(CONTEXT, "/GET_METRIC"),
    GET_COMPARISON: "".concat(CONTEXT, "/GET_COMPARISON"),
    ADD_COMPARISON: "".concat(CONTEXT, "/ADD_COMPARISON"),
    GET_TEMPLATE: "".concat(CONTEXT, "/GET_TEMPLATE"),
    SAVE_TEMPLATE: "".concat(CONTEXT, "/SAVE_TEMPLATE"),
    DELETE_TEMPLATE: "".concat(CONTEXT, "/DELETE_TEMPLATE"),
    LOAD_TEMPLATE: "".concat(CONTEXT, "/LOAD_TEMPLATE")
};
// eslint-disable-next-line max-len
var formatComparisonData = function(data) {
    return data.reduce(function(ac, a) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ac), (0,_define_property/* default */.Z)({}, a.fitem_id, a.value));
    }, {});
};
// Effects
var effects = {
    getMetric: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_METRIC, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, _$error, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return comparison.getComparisonMetric();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get comparison metric failed");
                case 6:
                    _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // Get initial comparison data
    getComparisons: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPARISON, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return comparison.getIndustrySectorRatio(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get comparisons failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    addComparison: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.ADD_COMPARISON, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var sourceSymbol, symbols, response, mappedRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        sourceSymbol = param.sourceSymbol, symbols = param.symbols;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return Promise.all(symbols.map(function(symbol) {
                            return comparison.getComparison({
                                symbol: symbol
                            });
                        }));
                    case 4:
                        response = _ctx.sent;
                        mappedRes = response.reduce(function(a, b) {
                            var ref, ref1;
                            return (0,_to_consumable_array/* default */.Z)(a).concat((0,_to_consumable_array/* default */.Z)((b === null || b === void 0 ? void 0 : (ref = b.data) === null || ref === void 0 ? void 0 : ref.data) && !((ref1 = b.data) === null || ref1 === void 0 ? void 0 : ref1.error) ? [
                                b.data.data
                            ] : []));
                        }, []);
                        if (mappedRes.length) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to add comparison failed");
                    case 8:
                        return _ctx.abrupt("return", {
                            data: mappedRes,
                            sourceSymbol: sourceSymbol
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getTemplates: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_TEMPLATE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return comparison.getComparisonTemplate(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get comparison template failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    saveTemplate: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.SAVE_TEMPLATE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return comparison.saveComparisonTemplate(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to save comparison template failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    removeTemplate: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.DELETE_TEMPLATE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(templateId) {
            var response, _data, data, _$error, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return comparison.deleteComparisonTemplate(templateId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to delete comparison template failed");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(templateId) {
            return _ref.apply(this, arguments);
        };
    }()),
    loadTemplate: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.LOAD_TEMPLATE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var symbol, templateId, response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, templateId = param.templateId;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return comparison.loadComparisonTemplate(templateId);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to load template failed");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {
    removeComparison: function(state, action) {
        var _payload = action.payload, symbol = _payload.symbol, sourceSymbol = _payload.sourceSymbol;
        var comparison = (0,_object_spread/* default */.Z)({}, state.comparison[sourceSymbol]);
        delete comparison[symbol];
        state.comparison[sourceSymbol] = comparison;
        state.competitors = state.competitors.filter(function(x) {
            return x.toUpperCase() !== symbol.toUpperCase();
        });
    },
    setShouldLoadDetail: function(state, action) {
        state.shouldLoadDetail = action.payload;
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getMetric.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
        if (error) {
            state.error = error;
        } else {
            state.metric = data;
            state.error = null;
        }
        state.message = message;
    }).addCase(effects.getComparisons.pending, function(state) {
        state.error = null;
        state.isLoading = true;
    }).addCase(effects.getComparisons.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.competitors = data.competitor.map(function(c) {
                return c.symbol.toUpperCase();
            });
            var comparisonData = {
                _industry: formatComparisonData(data.industry),
                _sector: formatComparisonData(data.sector)
            };
            state.comparison[symbol] = comparisonData;
            state.error = null;
            state.shouldLoadDetail = true;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.addComparison.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, sourceSymbol = _payload.sourceSymbol;
        if (error) {
            state.error = error;
        } else {
            data.forEach(function(d) {
                state.comparison[sourceSymbol][d.symbol] = formatComparisonData(d.data_value);
                if (state.competitors.indexOf(d.symbol) === -1) state.competitors = (0,_to_consumable_array/* default */.Z)(state.competitors).concat([
                    d.symbol.toUpperCase(), 
                ]);
            });
            state.error = null;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getTemplates.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.template[symbol] = data.map(function(t) {
                return {
                    id: t.save_id,
                    name: t.save_name
                };
            });
            state.error = null;
        }
        state.message = message;
        state.isLoading = false;
    })// Add and remove template layout doesn't affect reducer since we will refetch template list
    // after success do both
    .addCase(effects.loadTemplate.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.loadTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.competitors = data.competitor.map(function(c) {
                return c.symbol;
            });
            var comparisonData = {
                _industry: formatComparisonData(data.industry),
                _sector: formatComparisonData(data.sector)
            };
            state.comparison[symbol] = comparisonData;
            state.error = null;
            state.shouldLoadDetail = true;
        }
        state.message = message;
        state.isLoading = false;
    });
};
var comparison_comparison = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "comparison",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var entities_comparison = (comparison_comparison);


/***/ }),

/***/ 4822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var lib_api_fundachart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99376);






// APIs
// Initial state
var initialState = {
    metric: [],
    template: {},
    chart: {},
    isLoading: false,
    error: null,
    message: ""
};
var fundachartSelector = function(state) {
    return state.entities.fundachart;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(fundachartSelector, function(fundachart) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, fundachart);
});
// Action types
var CONTEXT = "@redux/fundachart";
var actionType = {
    GET_METRIC: "".concat(CONTEXT, "/GET_METRIC"),
    GET_FUNDACHART: "".concat(CONTEXT, "/GET_FUNDACHART"),
    GET_TEMPLATE: "".concat(CONTEXT, "/GET_TEMPLATE"),
    SAVE_TEMPLATE: "".concat(CONTEXT, "/SAVE_TEMPLATE"),
    REMOVE_TEMPLATE: "".concat(CONTEXT, "/REMOVE_TEMPLATE")
};
// Side effects
var effects = {
    getFundachartMetric: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_METRIC, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_fundachart__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getFundachartMetric */ .Z.getFundachartMetric();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get fundachart metric failed");
                case 6:
                    response.data.data = response.data.data.map(function(dt) {
                        return {
                            id: dt.fitem_id,
                            name: dt.fitem_name,
                            show_chart_icon: dt.show_chart_icon,
                            childs: dt.child.map(function(dtc1) {
                                return {
                                    id: dtc1.fitem_id,
                                    name: dtc1.fitem_name,
                                    show_chart_icon: dtc1.show_chart_icon,
                                    childs: dtc1.child.map(function(dtc2) {
                                        return {
                                            id: dtc2.fitem_id,
                                            name: dtc2.fitem_name,
                                            show_chart_icon: dtc2.show_chart_icon,
                                            childs: []
                                        };
                                    })
                                };
                            })
                        };
                    });
                    _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 10:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }))),
    getFundachart: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_FUNDACHART, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
            var symbol, params, response, newResponse, ref, ref1, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = _param.symbol, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
                            "symbol"
                        ]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_fundachart__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getFundachart */ .Z.getFundachart(params);
                    case 4:
                        response = _ctx.sent;
                        newResponse = null;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error("Attempt to get fundachart failed");
                    case 10:
                        {
                            ;
                            newResponse = {
                                data: [],
                                message: response.data.message
                            };
                            (((ref = response.data) === null || ref === void 0 ? void 0 : ref.data) || []).forEach(function(dt) {
                                dt.ratios.forEach(function(ratio) {
                                    var chartData = ratio.chart_data.map(function(cd) {
                                        return [
                                            cd.date * 1000,
                                            cd.value, 
                                        ];
                                    });
                                    if (chartData.length) {
                                        var newData = {
                                            data: chartData,
                                            companyid: dt.company_id,
                                            company: dt.company_name,
                                            itemid: ratio.item_id,
                                            name: "".concat(dt.company_name, " ").concat(ratio.item_name),
                                            yAxis: ratio.yaxis_id - 1,
                                            suffix: ratio.suffix,
                                            groupdata: ratio.group_data,
                                            decimal: ratio.decimal_point,
                                            show: true,
                                            itemName: ratio.item_name
                                        };
                                        newResponse.data.push(newData);
                                    }
                                });
                            });
                        }
                    case 11:
                        ref1 = newResponse || response.data, _$error = ref1.error, message = ref1.message, data = ref1.data;
                        if (!_$error) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 14:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol
                        });
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17
                ]
            ]);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }()),
    getFundachartTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_TEMPLATE, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_fundachart__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getFundachartTemplate */ .Z.getFundachartTemplate();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get fundachart template failed!");
                case 6:
                    _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    saveFundachartTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.SAVE_TEMPLATE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_fundachart__WEBPACK_IMPORTED_MODULE_1__/* ["default"].saveFundachartTemplate */ .Z.saveFundachartTemplate(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to save template failed");
                    case 6:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    removeFundachartTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.REMOVE_TEMPLATE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateId) {
            var response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_fundachart__WEBPACK_IMPORTED_MODULE_1__/* ["default"].removeFundachartTemplate */ .Z.removeFundachartTemplate(templateId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to remove template failed");
                    case 6:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(templateId) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {};
var extraReducers = function(builder) {
    builder.addCase(effects.getFundachartMetric.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            state.metric = data;
            state.error = null;
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(effects.getFundachart.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getFundachart.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.error = error;
        } else {
            state.chart[symbol] = data;
            state.error = null;
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(effects.getFundachartTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
        if (error) {
            state.error = error;
        } else {
            state.template = data;
            state.error = null;
        }
        state.isLoading = false;
        state.message = message;
    });
// save and remove fundachart template doesn't affect reducer since everytime those two
// executed, we will re-fetch the template list
};
var fundachart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "fundachart",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (fundachart);


/***/ })

}]);